import FilterTees from './FilterTees'

export default FilterTees
